import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-detalle-totem',
  templateUrl: './detalle-totem.component.html',
  styleUrls: ['./detalle-totem.component.css']
})
export class DetalleTotemComponent implements OnInit {
  @Input('detalle') detalleTotem
  @Input('detalleDir') detalleTotemDir
  public readytoShow = false
  public infoDetalle
  public resoluciones
  public permisos
  public recepcion

  constructor() {

  }

  ngOnInit(): void {

    if (this.detalleTotem) {
      console.log(this.detalleTotem.portalData.Conj_Hab_Resoluciones)
      this.resoluciones = [...(this.detalleTotem.portalData.Conj_Hab_Resoluciones)]
      this.permisos = [...(this.detalleTotem.portalData.Conj_Hab_Permiso)]
      this.recepcion = [...(this.detalleTotem.portalData.Conj_Hab_Recepciones)]
      this.infoDetalle = this.detalleTotem

    } else if (this.detalleTotemDir) {
      this.infoDetalle = this.detalleTotemDir.info
      console.log(this.infoDetalle)
      this.resoluciones = [...(this.infoDetalle.portalData.Conj_Hab_Resoluciones)]
      this.permisos = [...(this.infoDetalle.portalData["Conj_Hab_Permiso 2"])]
      this.recepcion = [...(this.infoDetalle.portalData["Conj_Hab_Recepciones 2"])]
    }

  }

  downloadDocument(documentoUrl) {
    let newUrl = documentoUrl.replace(/\\/g, `/`);
    let finalUrl = newUrl.replace("Z:", "http://10.1.17.90/download.php?rdoc=")

    window.open(finalUrl, '_blank');
  }

}
